export default Object.freeze({
    // STATISTIC_SALES_
    SALES_STATISTICS: '판매통계',
    TAB_PERIOD: '기간별 판매현황',
    TAB_PRODUCT: '상품 판매현황',
    TAB_CATEGORY: '카테고리 판매현황',
    CLAIM: '클레임',
    DIVISION: '구분',
    EXCEPT: '제외',
    INCLUDE: '포함',
    CLAIM_EXCEPT: '결제(입금)완료 건만 조회',
    CLAIM_INCLUDE: '결제(입금)완료 – 취소완료(환불완료) – 반품완료(환불완료) – 교환완료(환불완료) - 교환완료(결제완료) - 교환완료',
    NUMBER_SALES: '판매건수 : 클레임 포함 조회시 부분취소(반품)일 경우 판매(주문)건수에는 포함되지 않습니다.',
    SALE_PRICE_A: '판매금액(A) : 판매가 – 즉시할인가 - 정기결제(배송) 즉시할인가',
    PROMOTIONAL_PRODUCT_DISCOUNT_B: '프로모션 상품할인금액(B) : 추가 할인금액 + 상품 금액 할인',
    TOTAL_PRODUCT_SALES_C: '총 상품판매금액(C) : 판매금액(A) - 프로모션 상품할인금액(B)',
    EXCEL_DOWNLOAD_1: '※ 엑셀다운로드 : 조회조건에 따른 엑셀 다운로드시 해당 상품/옵션이 포함된 주문 건이 다운로드됩니다.(주문번호 기준)',
    EXCEL_DOWNLOAD_2: '회원그룹으로 조회 시,복수 회원그룹을 가진 회원의 데이터가 이중 집계되어 오차가 발생할 수 있습니다.',
    PARTNER: '파트너 ',
    MEMBER_TYPE: '회원유형',
    MEMBER_SHIP_GENDER: '회원성별',
    PLATFORM: '플랫폼구분',
    MALE: '남성',
    FEMALE: '여성',
    UNCLASSIFIED: '미분류',
    MEMBER_SHIP_LEVEL: '회원등급',
    MEMBER_GROUP: '회원그룹',
    CLAIM_CLASSIFICATION: '클레임구분',
    SELECT_FALSE: '클레임제외',
    SELECT_TRUE: '클레임포함',  
    STANDARD_CATEGORY: '표준카테고리',
    TERM: '기간',
    TARGET_TYPE_BRAND: '브랜드',
    PLATFORM_TYPE_PC: 'PC',
    PLATFORM_TYPE_MOBILE_WEB: '모바일 웹',
    PLATFORM_TYPE_MOBILE_APP: '모바일 앱',
    BRAND_SEARCH: '브랜드명 입력',
    PARTNER_SEARCH: '파트너명 입력',
    ISSUE_PLATFORM: '발급가능 플랫폼',
    TITLE: '기간별 카테고리 판매현황 종합',
    TITLE_PRODUCT: '기간별 상품 판매현황 종합',
    INQUIRY_PERIOD: '조회기간',
    SHOPPING_MALL: '쇼핑몰',
    TITLE1: '카테고리 세부판매현황',
    PERIOD: '기간별',
    MONTH: '월별',
    MALL: '쇼핑몰회원',
    PAYCO: 'PAYCO아이디회원',
    OPENID: 'OpenID 회원',
    NEOID: '통합관리회원',
    TOTALORDERCNT: '판매건수',
    TOTALPRODUCTCNT: '판매상품수',
    TOTALSALECNT: '판매수량',
    TOTALSALEAMT: '판매금액(A)',
    TOTALPRODUCTPROMOTIONDISCOUNTAMT: '프로모션 상품할인금액(B)',
    TOTALPRODUCTSALEAMT: '총 상품판매금액(C) (C=A-B)',
    EXCELBTN: '상세보기',
    CATEGORYNAME: '표준카테고리',
    TOTALCOMMISSIONAMT: '판매수수료(AA)',
    TOTALMALLPROMOTIONAMT: '프로모션 상품할인금액(쇼핑몰)(B1)',
    TOTALPARTNERPROMOTIONAMT: '프로모션 상품할인금액(파트너)(B2)',
    TOTALPAYAMT: '총 상품판매금액(C)(C=A-B1-B2)',
    TOTALMALLPROFITAMT: '쇼핑몰수익(BB)(BB=AA-B1)',
    TITLE_NOTE: '(* 네이버페이 주문형으로 결제한 주문의 네이버 조정금액으로 인해 오차가 발생할 수 있습니다. 상세 금액은 네이버페이센터를 통해 확인해 주세요.)',
    TITLE_NOTE1: '판매수수료는 주문 시점 상품 수수료기준으로 산출됩니다.',
    TITLE_NOTE2: '판매수수료 계산 방식 : 공급가 직접 입력인 경우(판매금액-공급가), 상품수수료율 방식인 경우(판매금액*수수료율), 사입상품인 경우(판매금액-매입가)',
    SEARCH_CRITERIA: '조회기준',
    PRODUCT: '상품별',
    OPTION: '옵션별',
    SALE_METHOD: '판매방식구분',
    ALL: '전체',
    PURCHASE: '사입',
    CONSIGNMENT: '위탁',
    TESTAREA_PLACEHOLDER: '상품번호로만 조회 가능합니다. (복수 시 Enter 또는 “,” 로 구분)',

    PROMOTIONTYPE: '프로모션 할인금액 구분(B)',
    TOTALPROMOTIONAMT: '할인금액 합계',
    MERGEMALL: '쇼핑몰 부담',
    MERGEPARTNER: '파트너 부담',
    TOTALMALLDISCOUNTAMT: '할인금액',
    MALLDISCOUNTRATE: '비율(%)',
    TOTALPARTNERDISCOUNTAMT: '할인금액',
    PARTNERDISCOUNTRATE: '비율(%)',
    PRODUCT_TABLE_TITLE: '상품 세부판매현황',
    MALLPRODUCTNO: '상품번호',
    PRODUCTMANAGEMENTCD: '상품관리코드',
    PRODUCTNAME: '상품명',
    MALLNAME: '쇼핑몰',
    SALEMETHODTYPELABEL: '판매방식',
    PURCHASEYN: '공급가<br>입력',
    TOTALPURCHASEPRICE: '공급가액',
    TOTALSUPPLYPRICE: '매입가액',
    COMMISSIONRATE: '수수료율',
    MALLOPTIONNO: '옵션번호',
    DISPLAYOPTIONNAME: '옵션명: 옵션값',



    // error message
  ERR_MALLNO_NULL: '쇼핑몰을 선택해주세요.',
  ERR_COUPONNAME_NULL: '쿠폰명을 입력해 주세요.',
  ERR_ISSUELIMITCNT_NULL: '발급 수량을 입력 해주세요.',
  ERR_ISSUELIMITCNT_0: '발급 수량은 0으로 입력할 수 없습니다.',
  ERR_ISSUETIME: '발급 종료 시간은 시작시간보다 미래로 설정해주세요.',
  ERR_REGISTERPERPERSON_NULL: '1인당 등록가능 수량을 입력하세요',
  ERR_REGISTERPERPERSON_0: '1인당 등록가능수량을 0으로 입력하실 수 없습니다.',
  ERR_REGISTERPERPERSON_BETWEEN: '1인당 등록가능수량을 전체쿠폰발행수량 이하로 입력 해 주세요',
  ERR_COUPONCODELENGTH_NULL: '난수 자리수를 입력하세요',
  ERR_COUPONCODELENGTH_GREATERTHEN: '난수쿠폰은 5자리 미만으로 설정할 수 없습니다.',
  ERR_COUPONCODELENGTH_LESSTHEN: '난수쿠폰은 20자리를 초과하도록 설정할 수 없습니다.',
  ERR_PROMOTIONCODE_NULL: '난수 자리수를 입력하세요',
  ERR_DAILYISSUELIMIT_NULL: '1일 발급 제한 수량을 입력하세요.',
  ERR_DAILYISSUELIMIT_0: '1일 발급제한 수량은 0으로 입력할 수 없습니다.',
  ERR_DAILYISSUELIMIT_BETWEEN: '1일 발급제한 수량을 쿠폰발행수량 이하로 입력 해 주세요',
  ERR_ISSUEPERPERSONLIMIT_NULL: '기간 내 발행제한 수량을 입력하세요',
  ERR_ISSUEPERPERSONLIMIT_0: '기간 내 발행제한 수량은 0으로 입력할 수 없습니다.',
  ERR_ISSUEPERPERSONLIMIT_BETWEEN: '기간 내 발행제한 수량을 쿠폰발행수량 이하로 입력 해 주세요.',
  ERR_DAILYISSUEPERPERSONLIMITCNT_NULL: '1일 내 발행제한 수량을 입력하세요',
  ERR_DAILYISSUEPERPERSONLIMITCNT_0: '1일 내 발행제한 수량은 0으로 입력할 수 없습니다.',
  ERR_DAILYISSUEPERPERSONLIMITCNT_BETWEEN: '1일 내 발행제한 수량을 쿠폰발행수량 이하로 입력 해 주세요',
  ERR_PERPERSONLIMIT_NULL: '1인당 발급수량 제한을 확인 해 주세요',
  ERR_ISSUABLEPLATFORM_NULL: '발급가능 플랫폼을 1개 이상 선택 해 주세요.',
  ERR_DAYSOFWEEK_NULL: '발급가능 요일을 1개 이상 선택 해 주세요.',
  ERR_MINSALE_NULL: '최소기준금액을 입력해 주세요.',
  ERR_GREATERTHEN_9: '기준금액을 10원보다 작게 입력하실 수 없습니다.\n기준금액을 다시 확인해주세요.',
  ERR_MAXSALE_NULL: '최대기준금액을 입력해 주세요.',
  ERR_SALEPRICE_BETWEEN: '최대기준금액을 입력해 주세요.',
  ERR_DISCOUNT_NULL: '할인금액을 입력 해 주세요.',
  ERR_DISCOUNT_9: '할인금액을 10원보다 작게 입력하실 수 없습니다.\n할인금액을 다시 확인해주세요.',
  ERR_DISCOUNT_BETWEEN: '할인금액을 할인 기준금액보다 작게 입력해 주세요.',
  ERR_PERCENT_NULL: '정률할인의 할인률을 입력 해 주세요.',
  ERR_PERCENT_0: '할인률을 0%로 입력하실 수 없습니다.',
  ERR_PERCENT_100: '할인률을 100% 이상으로 입력하실 수 없습니다.',
  ERR_MAXDISCOUNT_NULL: '최대 할인금액을 입력하세요.',
  ERR_MAXDISCOUNT_9: '최대 할인금액을 10원보다 작게 입력하실 수 없습니다.\n최대 할인금액을 다시 확인해주세요.',
  ERR_USABLEPLATFORM_NULL: '사용가능 플랫폼을 1개 이상 선택 해 주세요.',
  ERR_USEDAYS_NULL: '사용가능 기간을 선택하세요',
  ERR_BRAND_NULL: '할인대상 브랜드를 추가 해 주세요.',
  ERR_CATEGORY_NULL: '할인대상 카테고리를 추가 해 주세요.',
  ERR_PARTNER_NULL: '할인대상 파트너를 추가 해 주세요.',
  NO_RESULTS: '검색결과가 없습니다.',
  ERR_MAX_PRODUCTS_NO: '상품번호 검색은 최대 300개까지 입력이 가능합니다.',
});
